import React, {ChangeEvent, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import CustomRverceMultiCheckbox from '../../../components/mazraeKit/customReverceMultiCheckbox';
import SearchBox from '../../../components/mazraeKit/searchBox';
import {RootState} from '../../../store/redux';
import {
  clearAddress,
  ISelected,
  removeState,
  replaceAddress,
} from '../../../store/redux/searchingLocation';
import UseGetProvince from '../../../utilities/hooks/province/useGetProvince';
import {useSafeNavigateBack} from '../myStore/pages/myStoreAdvertisement/useSafeNavigate';

const AddLocation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {provinces} = UseGetProvince();
  const [searchText, setSearchText] = useState('');
  const [locational, setLocational] = useState<Array<ISelected>>([]);
  const safeNavigateBack = useSafeNavigateBack(
    location?.state?.from ?? '/home',
  );

  const selectedProvince = provinces?.filter(
    (province: IProvince, index: number) =>
      province?.id === location.state?.stateId,
  )[0];
  const state = useSelector((state: RootState) => state.searchingLocation);
  useEffect(() => {
    state.locational && setLocational(state.locational);
  }, [state.locational]);

  const onClickHandler = (
    e: ChangeEvent<HTMLInputElement>,
    title: string,
    id: string,
  ) => {
    if (e.target.checked) {
      e.target.value &&
        setLocational(prev => [
          ...prev,
          {
            guid: e.target.value,
            value: title,
            id: id,
            stateGuid: location.state?.stateId,
            stateTitle: location.state?.stateName,
          },
        ]);
    } else {
      setLocational(prev => prev.filter(elem => elem.id !== id));
    }
  };

  const handleActiveAllCities = () => {
    selectedProvince?.cities &&
      setLocational(
        selectedProvince?.cities.map(item => {
          return {
            guid: item.guid || '',
            value: item.name,
            id: String(item.id),
            stateGuid: location.state?.stateId,
            stateTitle: location.state?.stateName,
          };
        }),
      );
  };

  function areObjectsEqual(obj1: ISelected, obj2: ISelected) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }

    return true;
  }

  const handleRemoveState = (guid?: string) => {
    dispatch(
      removeState(
        locational.filter(item => String(item.stateGuid) !== String(guid)),
      ),
    );
  };
  function areArraysEqual(array1: Array<ISelected>, array2: Array<ISelected>) {
    if (array1.length !== array2.length) {
      return false;
    }

    for (const obj1 of array1) {
      const match = array2.some(obj2 => areObjectsEqual(obj1, obj2));
      if (!match) {
        return false;
      }
    }

    return true;
  }

  const stateGrouper = () => {
    const states: Record<string, Array<ISelected>> = {};
    locational.forEach(item => {
      if (item.stateGuid && item.stateGuid in states) {
        states[item.stateGuid as string] = [...states[item.stateGuid], item];
      } else {
        states[item.stateGuid as string] = [item];
      }
    });

    const newprovinces = provinces
      ?.filter(item => item.id in states)
      .map(item => {
        return {
          type: item.cities.length === states[item.id].length ? 'all' : 'some',
          stateGuid: item.id,
          stateTitle: item.name,
          cities: states[item.id] || [],
        };
      });
    return {newprovinces, states};
  };

  const newState = stateGrouper();

  const handleSuccessNavigate = () => {
    dispatch(replaceAddress(locational));
    setLocational(locational);

    if (location.state?.from) {
      navigate(location.state.from);
      return;
    }
  };

  return (
    <div className="flex flex-col w-full h-full ">
      <div className="flex h-[56px] w-full px-4 justify-between items-center text-md text-black">
        <div className="flex items-center">
          <span>انتخاب شهرستان</span>
        </div>
        <SpanIcon
          className="text-2xl text-black icon-nameClose-remove"
          onClick={() => {
            setLocational([]);
            dispatch(clearAddress());
            navigate('/choose-location', {
              state: {from: location?.state?.from},
            });
          }}
        />
      </div>
      <hr className="mx-2 mt-0 text-gray-300" />
      <div className="px-4">
        <SearchBox
          title=" جستجو در شهرستان..."
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setSearchText(e.target.value)
          }
        />
      </div>

      <div className="flex gap-1 px-4 mt-3 overflow-x-auto">
        {newState.newprovinces?.map((item, index) =>
          item.type === 'all' ? (
            <div
              key={index}
              className="flex items-center justify-between gap-2 px-3 py-2 rounded-full whitespace-nowrap bg-farm-shop-100 text-farm-shop-600"
            >
              <span className="text-sm">همه شهرستان‌های {item.stateTitle}</span>
              <i
                className="icon-nameClose-remove"
                onClick={() => {
                  handleRemoveState(String(item.stateGuid));
                }}
              />
            </div>
          ) : (
            <React.Fragment key={index}>
              {item.cities.map(cityItem => (
                <div className="flex items-center justify-between gap-2 px-3 py-2 rounded-full whitespace-nowrap bg-farm-shop-100 text-farm-shop-600">
                  <span className="text-sm">{cityItem.value}</span>
                  <i
                    className="icon-nameClose-remove"
                    onClick={() => {
                      setLocational(prev =>
                        prev.filter(elem => elem.guid !== cityItem.guid),
                      );
                    }}
                  />
                </div>
              ))}
            </React.Fragment>
          ),
        )}
      </div>
      {selectedProvince && (
        <button
          onClick={() =>
            navigate('/choose-location', {
              state: {from: location?.state?.from},
            })
          }
          className="flex items-center gap-2 px-4 py-4 mr-1 text-gray-900 border-b text-md font-Regular"
        >
          <SpanIcon className="icon-nameArrow---Right text-[20px]" />
          <span>همه شهرها</span>
        </button>
      )}
      <div className="flex flex-col flex-1 px-4 overflow-y-auto">
        {selectedProvince?.cities && (
          <div className="py-4 mr-1 border-b">
            <CustomRverceMultiCheckbox
              title={`همه شهرستان‌های ${selectedProvince?.name}`}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                location.state?.stateId in newState.states &&
                newState.states[location.state?.stateId].length ===
                  selectedProvince?.cities.length
                  ? handleRemoveState(String(selectedProvince.id))
                  : handleActiveAllCities();
              }}
              value={'all'}
              checked={
                location.state?.stateId in newState.states &&
                newState.states[location.state?.stateId].length ===
                  selectedProvince?.cities.length
              }
            />
          </div>
        )}

        {selectedProvince?.cities
          .filter(item => item.name?.includes(searchText))
          ?.map((item: ICity) => {
            return (
              <div className="py-4 mr-1 border-b">
                <CustomRverceMultiCheckbox
                  title={item.name}
                  id={item.id.toString()}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    onClickHandler(e, String(item.name), String(item.id));
                  }}
                  value={item.guid}
                  checked={
                    locational.find(
                      selectItem => selectItem.guid === String(item.guid),
                    )
                      ? true
                      : false
                  }
                />
              </div>
            );
          })}
      </div>

      <div className="flex justify-between w-full px-4 py-3 rounded-t-lg shadow-dropShadow">
        <button
          onClick={() => {
            setLocational(state.locational);
            safeNavigateBack();
          }}
          className="flex h-[48px]  w-[45%]  items-center justify-center text-md font-Medium text-red-500 border-red-500 rounded-[8px] border-[1px] "
        >
          انصراف
        </button>
        <button
          disabled={areArraysEqual(locational, state.locational)}
          onClick={handleSuccessNavigate}
          className="flex disabled:bg-gray-200 bg-farm-shop-500 text-white w-[45%] h-[48px]  items-center justify-center text-md font-Medium disabled:text-gray-500 rounded-[8px]"
        >
          تأیید
        </button>
      </div>
    </div>
  );
};

export default AddLocation;
